import { EngagementListener } from "../core/internal/engagement/EngagementListener"
import { LifecycleChangeListener } from "../core/internal/lifecycle/LifecycleChangeListener"
import { PageListener } from "../core/internal/page/PageListener"
import { LifecycleComposite, LifecycleCompositeManager } from "../core/internal/lifecycle/LifecycleComposite"
import { LifecycleManager } from "../core/internal/lifecycle/LifecycleManager"
import { PageManager } from "../core/internal/page/PageManager"
import { EngagementManager } from "../core/internal/engagement/EngagementManager"
import { DEFAULT_ENGAGEMENT_DURATION_MILLIS } from "../config"

/**
 * @exports WebViewLifecycleCompositeManager, a composite manager for web view lifecycle only.
 */
class WebViewLifecycleCompositeManager implements LifecycleComposite {
  private readonly compositeManager: LifecycleCompositeManager

  constructor(browserName: string | null, engagementDurationMillis: number = DEFAULT_ENGAGEMENT_DURATION_MILLIS) {
    const lifecycleManager = new LifecycleManager()
    const pageManager = new PageManager()
    const engagementManager = new EngagementManager(pageManager, engagementDurationMillis)

    this.compositeManager = new LifecycleCompositeManager(lifecycleManager, pageManager, engagementManager, browserName)
    this.compositeManager.addLifecycleListener(this.compositeManager.pageManager)
  }

  addPageListener(listener: PageListener): void {
    this.compositeManager.addPageListener(listener)
  }
  addEngagementListener(listener: EngagementListener): void {
    this.compositeManager.addEngagementListener(listener)
  }
  addLifecycleListener(listener: LifecycleChangeListener): void {
    this.compositeManager.addLifecycleListener(listener)
  }
  initialize(): void {
    this.compositeManager.initialize()
  }
}

export { PageListener, EngagementListener, LifecycleChangeListener, WebViewLifecycleCompositeManager }
